import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponseModel, ApiVisa } from '../../shared';
import { Core2Config } from '../../shared';
import { SalesFavouriteItemLinkContainer } from '../../../../../../models/aggregates/erp/sales-favourite-item-link';
import { Observable } from 'rxjs';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({ providedIn: 'root' })
export class SalesFavouriteItemLinkService extends BaseApiPublicLoginTemplateService<SalesFavouriteItemLinkContainer, SalesFavouriteItemLinkContainer, SalesFavouriteItemLinkContainer> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'sales-fav-item-links/login-entity-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'sales-fav-item-links/login-entity-ep';
    this.httpClient = http;
  }

  public deleteByEntityAndItemId(guidEntity: string, guidItem: string, visa: ApiVisa): Observable<ApiResponseModel<SalesFavouriteItemLinkContainer>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.delete<ApiResponseModel<SalesFavouriteItemLinkContainer>>(
      this.apiUrl + '/' + guidEntity + '/' + guidItem,
      this.getHttpHeader(visa)
    );
  }
}
